module.exports = __webpack_public_path__ + "img/conclusion6.08514ced.svg";